import { createFileRoute, notFound } from "@tanstack/react-router";
import type { AnalyticsView } from "@/lib/search-params";
import {
  MediaPerformancePage,
  MediaPerformancePending,
  mediaPerformanceLoader,
} from "./$orgSlug.index";

const SECTION_VIEW: Record<string, AnalyticsView> = {
  campaigns: "campaign",
  creatives: "creative",
};

export const Route = createFileRoute("/_authenticated/$orgSlug/media-performance/$section")({
  beforeLoad: ({ params }) => {
    if (!SECTION_VIEW[params.section]) throw notFound();
  },
  loaderDeps: ({ search }) => search,
  loader: ({ params, deps, context }) =>
    context.reportingView.unavailable.length
      ? undefined
      : mediaPerformanceLoader(
          params.orgSlug,
          deps,
          context.queryClient,
          params.section === "creatives",
        ),
  pendingMs: 200,
  pendingMinMs: 300,
  pendingComponent: MediaPerformancePending,
  component: MediaPerformanceSection,
});

function MediaPerformanceSection() {
  const { section } = Route.useParams();
  return <MediaPerformancePage viewOverride={SECTION_VIEW[section]} />;
}
